<template>
  <div class="container">
    <div class="columns">
      <div class="column is-half is-offset-one-quarter">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">Login</p>
          </header>
          <section class="card-content">
            <div class="content">
              <o-field label="Email">
                <o-input
                  type="email"
                  v-model="email"
                  placeholder="Your email"
                  required>
                </o-input>
              </o-field>

              <o-field label="Password">
                <o-input
                  type="password"
                  v-model="password"
                  password-reveal
                  placeholder="Your password"
                  required>
                </o-input>
              </o-field>
              <o-button variant="primary" @click="login()">Login</o-button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import {mapMutations} from "vuex";

export default {
  name: "Login",
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    ...mapMutations('auth', ['setAdmin']),
    login() {
      axios.post('/api/auth/login', {email: this.email, password: this.password})
        .then(response => {
          this.setAdmin(response.data)
          this.$router.push('/')
        })
        .catch(error => {
          this.$oruga.notification.open({
            message: error.response.data.message ? error.response.data.message : 'Something went wrong!',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })
          console.error(error)
        })
    }
  }
};
</script>

<style>

</style>
